import { gql } from "@stadium/services/apollo-client";

import { BUNDLE_PRODUCT_DETAILS } from "@graphql/fragments/product/kit-product-details";
import { KIT_PRODUCT_ADDITIONAL_DETAILS } from "@graphql/fragments/product/kit-product-additional-details";

export const fetchKitShopApi = gql`
  query fetchKitShop(
    $currency: String!
    $storeNumber: String!
    $country: String!
    $globalZone: Boolean
  ) {
    bundleShop(bundleShopNumber: $storeNumber) {
      id
      name
      externalId
      bundleState
      bundles {
        id
        name
        bundleZone
        number
        bundleProducts {
          ...BundleProductDetails
          ...KitProductAdditionalDetails
        }
        store {
          externalId
        }
      }
    }
  }
  ${BUNDLE_PRODUCT_DETAILS}
  ${KIT_PRODUCT_ADDITIONAL_DETAILS}
`;
